import { render, staticRenderFns } from "./SslDetailIframe.vue?vue&type=template&id=588ad552&"
import script from "./SslDetailIframe.vue?vue&type=script&lang=ts&"
export * from "./SslDetailIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports